import { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import '../styles/componentStyles/One2TenTracker.css';
import Warning from './Warning';

function One2TenTracker(props) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);
  const [showError, setShowError] = useState(false);
  const errorRef = useRef(null);

  useEffect(() => {
    if (props.data?.[props.questionid] === '') {
      setSelected(null);
    } else if (props.data?.[props.questionid]) {
      setSelected(props.data[props.questionid]);
    }
  }, [props.data, props.questionid]);

  const handleInvalidForm = useCallback(() => {
    if (props.required && !selected) {
      setShowError(true);
      if (errorRef.current) {
        errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        errorRef.current.focus();
      }
    }
  }, [props.required, selected]);

  useEffect(() => {
    document.addEventListener('invalid', handleInvalidForm, true);
    return () => document.removeEventListener('invalid', handleInvalidForm, true);
  }, [handleInvalidForm]);

  const handleClick = (event) => {
    const { value } = event.target;
    setShowError(false);

    if (selected === value) {
      setSelected(null);
      props.saveResponse('data', {
        id: props.questionid,
        value: null,
      });
    } else {
      setSelected(value);
      props.saveResponse('data', {
        id: props.questionid,
        value,
      });
    }
  };

  return (
    <div className="one-2-ten-cont">
      {showError && props.required && !selected && (
        <div className="validation-error" tabIndex="-1" ref={errorRef}>
          <Warning />
        </div>
      )}
      <div className="scale">
        <p>1 = {props.productivity ? t('T044') : t('T004')}</p>
        <p>10 = {props.productivity ? t('T045') : t('T005')}</p>
      </div>
      <div className="one-2-ten fs-exclude">
        {Array.from({ length: 10 }, (_, i) => {
          const value = (i + 1).toString();
          return (
            <div className="input_wrap" key={i}>
              <input
                type="radio"
                id={`${props.questionid}${value}`}
                name={props.questionid}
                value={value}
                checked={String(selected) === String(value)}
                onChange={handleClick}
                required={i === 0 && props.required}
              />
              <label htmlFor={`${props.questionid}${value}`}>{value}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default One2TenTracker;
